<button :type="type" :class="[defaultClass, btnClass, { 'is-loading': loading, 'with-loader': loader }]" :disabled="loading || disabled">
    <span :class="{ 'with-loader-text': loader }">
        <slot/>
    </span>
    <span v-if="loader" class="with-loader-spinner">
        <spinner/>
    </span>
</button>
